App.DeliveryZonesRestaurantZoneController = Em.Controller.extend
  session:  Em.inject.service()
  env:      Em.inject.service('environment')
  notifier: Em.inject.service()

  needs: ['deliveryZones' ]

  zonesBinding: 'controllers.deliveryZones.zones'
  zoneBinding: 'model'

  isEditingBinding: 'controllers.deliveryZones.isEditing'

  tabState: 'main'

  isTabMain:      Em.computed.equal('tabState', 'main')
  isTabTimetable: Em.computed.equal('tabState', 'timetable')
  isTabAdvanced:  Em.computed.equal('tabState', 'advanced')

  currencyUnit: Em.computed.alias('zone.restaurant.organization.currency.unit')

  isSaving: false

  showAdvancedTab: Em.computed.or('showAdvancedTabCourier', 'showAdvancedTabRush')

  showAdvancedTabCourier: (->
    (@get('env.features.courierAccounting') or  @get('zone.restaurant.organization.features.courier_accounting')) && @get('zone.isDelivery') 
  ).property('env.features')

  outsourceProviders: (->
    @get('env.features.deliveryOutsourceProviders')
  ).property('env.features')

  serviceChargeEnabled: (->
    @get('env.features.serviceCharge')
  ).property('env.features')

  showAdvancedTabRush: (->
    @get('env.features.restaurantRushMode') or @get('zone.restaurant.organization.features.restaurant_rush_mode')
  ).property('env.features')

  cookingLinesEnabled: (->
    @get('env.features.cookingLinesEnabled')
  ).property('env.features')

  isBoundsBlank:       Em.computed.equal('deliveryBoundsWarning', 'blank')
  isBoundsNotFeasible: Em.computed.equal('deliveryBoundsWarning', 'not_feasible')

  deliveryBoundsWarning: (->
    dt = Number(@get('zone.delivery_time'))
    tt = Number(@get('zone.transportation_time'))
    ct = Number(@get('zone.cooking_time'))

    if _.any([dt, tt, ct], _.isNaN) || !dt
      return 'blank'

    if dt < tt + ct
      return 'not_feasible'
  ).property('zone.delivery_time', 'zone.transportation_time', 'zone.cooking_time')

  helpPopupIsOpen: false
  helpPriorityPopupIsOpen: false


  actions:

    discardChanges: ->
      @transitionToRoute 'delivery.zones.restaurant', @get('zone.restaurant')
      false

    acceptChanges: ->
      return if @get('isSaving')

      zone = @get('zone')
      wasNewRecord = zone.get('isNew')


      # Для зон с самовывозом копируем общее время доставки
      # из времени приготовления
      if zone.get('isTakeaway') || zone.get('isDineIn')
        zone.set('rush_delivery_time', zone.get('rush_cooking_time'))
        zone.set('delivery_time', zone.get('cooking_time'))
        zone.set('transportation_time', 0)


      @set('isSaving', true)
      zone.save()
      .then =>
        # todo i18n
        text = if wasNewRecord
          "Зона доставки #{zone.get('name')} добавлена."
        else
          "Зона доставки #{zone.get('name')} обновлена."

        @get('notifier').pushNotification
          type: 'success'
          # todo i18n
          title: 'Сохранено'
          message: text
          duration: 3000
      .catch (e) =>
        messages = zone.get('errors.messages').join(', ')

        @get('notifier').pushNotification
          type: 'error'
          # todo i18n
          title: 'Ошибка сохранения'
          message: messages
      .finally =>
        @set('isSaving', false)
      false

    delete: ->
      # todo i18n
      if confirm 'Хотите удалить эту зону доставки?'
        zone = @get('zone')
        @get('zones').removeObject(zone)
        zone.destroyRecord().then (zone) =>
          @transitionToRoute 'delivery.zones.restaurant', @get('zone.restaurant')
      false

    editPolygon: ->
      @send('startEditing', @get('zone'))
      false

